"use client";

import { useRouter } from "next/navigation";

import { Button } from "@/components/button/button.component";
import { Text } from "@/components/text/text.component";

import { QUIZ_RESULTS_PAGE } from "@/constants/page.constants";

export const RetakeModalContent = ({
  data,
  onRetake,
  onClose,
}: RetakeModalContentProps) => {
  const router = useRouter();

  const handleGoToResults = () => {
    onClose();
    router.push(QUIZ_RESULTS_PAGE);
  };

  const handleTakeQuizAgain = () => {
    onClose();
    onRetake();
  };

  return (
    <div
      data-testid="retake-modal"
      className="flex flex-col items-center gap-4 px-4">
      <Text
        variant="h6"
        component="h2"
        className="text-greyscale-headline mt-8 text-center">
        {data.title}
      </Text>

      <Text variant="body4" className="text-greyscale-body text-center">
        {data.subtitle}
      </Text>

      <div className="mt-2 flex w-full flex-col gap-3 sm:flex-row">
        <Button
          secondary
          border
          onClick={handleTakeQuizAgain}
          className="flex-1 whitespace-nowrap"
          data-testid="retake-modal-restart">
          {data.takeQuizAgainLabel}
        </Button>
        <Button
          secondary
          onClick={handleGoToResults}
          className="flex-1 whitespace-nowrap"
          data-testid="retake-modal-results">
          {data.goToResultsLabel}
        </Button>
      </div>
    </div>
  );
};

type RetakeModalData = {
  title: string;
  subtitle: string;
  goToResultsLabel: string;
  takeQuizAgainLabel: string;
};

type RetakeModalContentProps = {
  data: RetakeModalData;
  onRetake: () => void;
  onClose: () => void;
};
